
export class Compradetalle {
    id:number;
    idCompra:number;
    idProducto:number;
    cod:string;
    nombre:string;
    iva:string;
    precioCosto:number;
    descuento:number;
    total:number;
    valorIva:number;
    cantidad:number;
    cantidadPedida:number;
    unidadCompra:string;
    factor:number;
    codigoPrincipal:string;
    codigoAuxiliar:string;
    caducidad:string;
    ordenar:number;
    }
    